/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/timestamp.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Returns the timestamp of each sample of the given vector as the number of seconds since January 1, 1970 UTC. It acts on float and histogram samples in the same way.
 *
 * @example
 * timestamp(http_requests_total)
 */
const definition: PromqlFunctionDefinition = {
  type: 'time',
  name: 'timestamp',
  signatures: [
    {
      params: [
        {
          name: 'v',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector input.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
